<template>
  <div v-if="mountElement && mount">
  <div v-if="amount !== '' && amount !== false && amount !== 0 && paymentBreakdown !== []">
    <div v-if="section || (!section && email)">
      <div>
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group authorize-elements">
              <form id="paymentForm" v-if="!userPaid">
                <h5 class="text-center" v-if="!section"> {{
                    computeCaption(this.fields_en['registration_sucessful'], this.$store.state.lang.value.toLowerCase()) + ' ' + email
                  }}</h5>
                <h4 class="text-center">
                  {{ computeCaption(this.fields_en['disclaimer'], this.$store.state.lang.value.toLowerCase()) }}</h4>
                <hr>
                <p v-html="disclaimer"></p>
                <payment-display :paymentArray="paymentBreakdown" :totalAmount="amount" />
                <br>
              </form>
              <card-section-authorize :paid="userPaid" @validateSection="validateSection" ref="cardSectionAuthorize"/>
              <br>
              <div class="mt-30">
                <button v-if="!section && !userPaid" :disabled="disabled"
                        class="btn btn-info btn-fill btn-wd btn-submit f-right payment-button"
                        @click.stop.prevent="delay">
                  <span>{{ computeCaption(buttonText, this.$store.state.lang.value.toLowerCase()) }}</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Used only for modal -->
    <div id="confirmationCode" style='display: none' v-if="!section">
      <h4 v-if="display_order_barcode">Confirmation Number: {{ confirmationNumber }}</h4>
      <barcode :value="confirmationNumber" v-if="display_order_barcode" class="text-center" format="CODE128">Show this
        if the rendering fails.
      </barcode>
    </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <hr>
        <br>
        <div class="form-group authorize-elements">
          <div>
            <div class="margin-justified">
              <div class="row">
                <p class="text-center col-md-12">
                  <b>{{
                      computeCaption(this.fields_en['payment_0'], this.$store.state.lang.value.toLowerCase())
                    }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert2'
import {FormatterUtils} from '../../../../../../utils/Formatter'
import {AmountUtils} from '../../../../../../utils/Amount'
import VueBarcode from 'vue-barcode'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {QuestionUtils} from '../../../../../../utils/Questions'
import {PatientInfoUtils} from '../../../../../../utils/PatientInfo'
import CardSectionAuthorize from './cardSectionAuthorize'
import PaymentDisplay from './paymentDisplay'

export default {
  mixins: [FormatterUtils, AmountUtils, SettingsUtils, TranslationsUtils, QuestionUtils, PatientInfoUtils],
  props: ['section'],
  data () {
    return {
      fields_en: {
        registration_sucessful: 'Registration sucessful, a confirmation email was sent to',
        disclaimer: 'DISCLAIMER',
        amount_to_be_charged: 'Based on your answers, the amount to be charged on credit card:',
        payment_0: 'For this registration, your payment amount is 0.'
      },
      timeout: null,
      amount: 0,
      paymentBreakdown: [],
      paymentLink: process.env.SERVER_URI + '/payment/authorize',
      buttonText: 'Pay Now',
      mountElement: false,
      allowSitePayment: this.isTrue(this.$store.state.configs.ALLOW_SITE_PAYMENT),
      disabled: false,
      disclaimer: '',
      userPaid: false,
      email: '',
      mount: false,
      confirmationNumber: '',
      display_order_barcode: this.$store.state.configs.DISPLAY_ORDER_BARCODE
    }
  },
  components: {
    PaymentDisplay,
    CardSectionAuthorize,
    'barcode': VueBarcode
  },
  beforeMount () {
    if (!this.section) {
      this.getSiteCodeConfigurations()
      this.checkIfUserPaid()
      this.getAmount(this.$route.params.id)
    } else {
      this.disclaimer = this.$store.state.site.payment_disclaimer
      this.mount = true
      this.computeAmount()
    }
    if (this.$store.state.configs.DISPLAY_ORDER_BARCODE === undefined) {
      this.display_order_barcode = false
    } else {
      this.display_order_barcode = this.$store.state.configs.DISPLAY_ORDER_BARCODE
    }
  },
  mounted () {
    this.mountElement = true
  },
  watch: {
    '$store.state.questions': {
      handler () {
        this.computeAmount()
      },
      deep: true
    },
    '$store.state.insuranceType': {
      handler (value) {
        this.computeAmount()
      }
    },
    '$store.state.configs.DISPLAY_ORDER_BARCODE': {
      handler (value) {
        this.display_order_barcode = this.$store.state.configs.DISPLAY_ORDER_BARCODE
      }
    },
    '$store.state.amount': {
      handler: function (before) {
        this.amount = this.$store.state.amount
      },
      immediate: true
    }
  },
  methods: {
    computeAmount () {
      this.amount = 0
      this.paymentBreakdown = []
      if (this.$store.state.site['payment_amount'] <= 0) {
        if (this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
          this.amount += parseFloat(this.$store.state.configs['AT_HOME_COLLECTION_FEE'])
          this.paymentBreakdown.push({'label': 'Collection Fee', 'value': '', 'price': parseFloat(this.$store.state.configs['AT_HOME_COLLECTION_FEE'])})
        }
        let result = this.computeQuestionAnswersPrice(this.$store.state.questions, this.amount, this.paymentBreakdown)
        this.amount = result.amount
        this.paymentBreakdown = result.paymentBreakdown
      } else {
        this.amount = parseFloat(this.$store.state.site['payment_amount'])
        this.paymentBreakdown.push({'label': 'Test Cost', 'value': '', 'price': this.amount})
        if (this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
          this.amount += parseFloat(this.$store.state.configs['AT_HOME_COLLECTION_FEE'])
          this.paymentBreakdown.push({'label': 'Collection Fee', 'value': '', 'price': parseFloat(this.$store.state.configs['AT_HOME_COLLECTION_FEE'])})
        }
      }
      this.$store.state.amount = this.amount
    },
    validate: function () {
      let validationAuth = this.$refs.cardSectionAuthorize.validate()
      return validationAuth
    },
    async checkIfUserPaid () {
      let info = await this.getPatientInfo()
      await axios.post(process.env.SERVER_URI + '/check_if_paid', { confirmation_number: this.$route.params.id, info: info })
        .then((response) => {
          this.mount = true
          this.userPaid = response.data.paid
          this.disclaimer = response.data.disclaimer
          this.email = response.data.email
        }).catch(error => {
          console.log(error)
        })
    },
    async sendPaymentDataToAnet () {
      let cardData = this.$refs.cardSectionAuthorize.validate()
      if (cardData) {
        this.disabled = true
        this.buttonText = 'Submitting.. Please wait'
        await axios.post(process.env.SERVER_URI + '/payment/authorize', { secureData: cardData, email: this.$store.state.dataForInsurance.email, confirmation_number: this.$route.params.id })
        .then((response) => {
          if (response.data === true) {
            let barcode = document.getElementById('confirmationCode')
            let langValue = this.$store.state.lang.value
            this.confirmationNumber = this.$route.params.id
            setTimeout(() => {
              swal({
                html: `<h2>Completed!</h2> <br><h4>Your Payment Has Been Successfully Received. </h4> <br> An email with additional details has been sent to ` + this.email + ` <br><br/>` + barcode.innerHTML + `
                               </b>
                           <br>
                           <div class="flex">
                          <button type="button" style="background: #51A7E9" class="btn-modal btn-complete">` + this.computeCaption('Complete', this.$store.state.lang.value.toLowerCase()) + `</button>
                          <button type="button" style="background: #79c5c5" class="btn-modal btn-new-patient">` + this.computeCaption('Register New Patient', this.$store.state.lang.value.toLowerCase()) + `</button>
                          </div>`,
                showCancelButton: false,
                showConfirmButton: false,
                width: 700,
                onBeforeOpen: () => {
                  const complete = document.querySelector('.btn-complete')
                  const patient = document.querySelector('.btn-new-patient')

                  complete.addEventListener('click', () => {
                    let urlTemp = window.origin + '/#/?lang=' + langValue
                    window.location.assign(urlTemp)
                    window.location.reload()
                    swal.close()
                  })

                  patient.addEventListener('click', () => {
                    if (this.$store.state.configs.SINGLE_PAGE_ORDERS) {
                      window.location.assign(window.origin + '/#/patient/order?site_code=' + this.siteCode)
                    } else {
                      window.location.assign(window.origin + '/#/patient/register/site-selection?site_code=' + this.siteCode)
                    }
                    window.location.reload()
                    swal.close()
                  })
                }
              }).catch(swal.noop)
            }, 2000)
          } else {
            swal('Error!', 'Something went wrong! <br> We could not process your payment! <br>' + response.data, 'error')
          }
        }).catch(error => {
          if (error.response.status === 403) {
            swal('Error!', 'Something went wrong! <br> The registration was not completed or the payment has already been made!', 'error')
          } else {
            swal('Error!', 'Something went wrong! <br> We could not process your payment!', 'error')
          }
        })
        this.disabled = false
        this.buttonText = 'Pay Now'
      }
    },
    async getSiteCodeConfigurations () {
      let confirmationNumber = this.$route.params.id
      await axios.get(process.env.SERVER_URI + '/get_code_configurations_by_confirmation_number/' + confirmationNumber)
        .then((response) => {
          this.overwriteGraphSettings(response.data)
          if (response.data.code) {
            this.siteCode = response.data.code
          }
        }).catch(error => {
          console.log(error)
        })
    },
    delay () {
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.disabled = false
        this.buttonText = 'Pay Now'
      }, 5000)

      this.sendPaymentDataToAnet()
    },
    validateSection (value) {
      this.$emit('validateSection', value)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
.margin-justified {
  margin-left:20px; margin-right:20px
}
.price-breakdown {
  border: 1px solid $default-grey;
  margin-bottom: 15px;
  padding: 5px 0px;
}
.background-grey {
  background-color: $default-grey;
}

.pc-hidden {
  display: none;
}

#card-errors{
  color: #f83f37;
}

.f-right{
  float: right;
}

.group {
    background: white;
    box-shadow: 0px 1px 3px #E7E8E9 !important;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
}

label {
    position: relative;
    color: #31325F;
    font-weight: 300;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    display: flex;
    flex-direction: row;
}

label > span {
    width: 80px;
    text-align: left;
}

.field {
    background: transparent;
    font-weight: 300;
    border: 0;
    color: #31325F;
    outline: none;
    flex: 1;
    padding-right: 10px;
    padding-left: 10px;
    cursor: text;
    padding-top: 0;
}

.radio-label{
  color: #474644;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.radio {
  margin: 0;
  margin-left: 10px;
}

.mt-6{
  margin-top: 6px;
}

.loading{
  margin-top: 30px;
}

.mt-30 {
  margin-top: 30px;
}

.authorize-elements label {
  margin-bottom: 0;
}

.card-label {
  line-height: 14px;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
}

@media screen and (max-width: 550px) {
  label > span {
    width: 40px;
    text-align: left;
    margin-right: 10px;
  }

  .field {
    background: transparent;
    font-weight: 300;
    border: 0;
    color: #31325F;
    outline: none;
    flex: 1;
    padding-right: 10px;
    padding-left: 40px;
    cursor: text;
    padding-top: 0;
}
}

@media screen and (max-width: 990px) {
  .pc-hidden {
    display: block;
  }
}
@media screen and (max-width: 1720px) {
  .mt-8 {
    margin-top: 0px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/PaymentParts/paymentOrderAuthorize.vue